import { useTranslation } from 'react-i18next';

const CARDS = [
  {
    titleKey: 's3.card1.title',
    descKey: 's3.card1.desc',
    img: 'https://readdy.ai/api/search-image?query=Premium%20single%20car%20enclosed%20garage%20of%20a%20luxury%20modern%20villa%20with%20one%20luxury%20car%20inside%2C%20anthracite%20dark%20facade%20with%20warm%20wood%20slats%20and%20gold%20accent%20lighting%2C%20minimalist%20luxury%20real%20estate%20aesthetic%2C%20dusk%20lighting%2C%20high%20detail%2C%20professional%20editorial%20architectural%20photography&width=800&height=600&seq=vg-card-single-01&orientation=landscape',
  },
  {
    titleKey: 's3.card2.title',
    descKey: 's3.card2.desc',
    img: 'https://readdy.ai/api/search-image?query=Spacious%20premium%20double%20car%20enclosed%20garage%20of%20a%20luxury%20modern%20villa%20with%20two%20luxury%20cars%20inside%2C%20anthracite%20dark%20facade%20with%20natural%20wood%20details%20and%20warm%20gold%20accent%20lighting%2C%20minimalist%20luxury%20aesthetic%2C%20high%20detail%2C%20professional%20editorial%20architectural%20photography&width=800&height=600&seq=vg-card-double-01&orientation=landscape',
  },
  {
    titleKey: 's3.card3.title',
    descKey: 's3.card3.desc',
    img: 'https://readdy.ai/api/search-image?query=Premium%20villa%20residential%20project%20with%20multiple%20integrated%20enclosed%20garage%20systems%2C%20modern%20architectural%20design%2C%20anthracite%20dark%20facades%20with%20warm%20wood%20and%20gold%20accent%20lighting%2C%20luxury%20development%2C%20dusk%20atmosphere%2C%20high%20detail%2C%20professional%20editorial%20photography&width=800&height=600&seq=vg-card-project-01&orientation=landscape',
  },
];

export default function GarageSystemsSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mb-5 inline-block h-px w-12 bg-primary-500"></span>
          <h2 className="font-heading text-3xl leading-tight text-foreground-950 md:text-4xl lg:text-5xl">
            {t('s3.title')}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((card, index) => (
            <a
              key={card.titleKey}
              href="#iletisim"
              className={`reveal img-hover-zoom group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${
                index === 0 ? '' : index === 1 ? 'reveal-delay-1' : 'reveal-delay-2'
              }`}
            >
              <div className="relative h-56 w-full overflow-hidden md:h-64">
                <img
                  src={card.img}
                  alt={t(card.titleKey)}
                  title={t(card.titleKey)}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="font-heading text-xl text-foreground-950 md:text-2xl">
                  {t(card.titleKey)}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                  {t(card.descKey)}
                </p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 transition-colors group-hover:text-primary-500">
                  {t('s3.cta')}
                  <i className="ri-arrow-right-line rtl:rotate-180" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}